module.exports = "# MME Level 2\n\nYouTube: hgkIlzjLLdE\n\n## Notes\n\nMessages From Mother Earth Episode 5 (2:43)\n\n\n# MME Level 3\n\nYouTube: 89E4ARNKSak\n\n## Notes\n\nMessages From Mother Earth Episode 6 (3:50)\n\n\n# MME Level 4\n\nYouTube: gmMfIzfXeyk\n\n## Notes\n\nMessages From Mother Earth Episode 7 (2:29)\n\n\n# MME Level 6\n\nYouTube: l5QHvKngfVg\n\n## Notes\n\nMessages From Mother Earth Episode 8 (2:34)\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/13_mme/mme.md
// module id = 1841
// module chunks = 2